export const categories = [
  { slug: "movie", name: "电影", icon: "ri-film-line" },
  { slug: "tv", name: "电视剧", icon: "ri-tv-line" },
  { slug: "variety", name: "综艺", icon: "ri-live-line" },
  { slug: "anime", name: "动漫", icon: "ri-ghost-line" },
  { slug: "documentary", name: "纪录片", icon: "ri-camera-lens-line" },
  { slug: "short", name: "短剧", icon: "ri-clapperboard-line" },
];

export const videos = [
  {
    id: 1,
    title: "流浪地球3",
    category: "movie",
    year: 2026,
    rating: 9.2,
    thumbnail: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20astronauts%20and%20massive%20spaceship%20in%20deep%20space%2C%20dramatic%20lighting%2C%20cinematic%20movie%20poster%20style%2C%20orange%20and%20teal%20color%20grading&width=640&height=360&seq=video-thumb-01&orientation=landscape",
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅程，年轻一代挺身而出，展开一场跨越时空的生死之战。本片是流浪地球系列的第三部作品，延续前作宏大的科幻世界观。",
    tags: ["科幻", "冒险", "灾难", "国产"],
    director: "郭帆",
    cast: ["吴京", "刘德华", "李雪健"],
    duration: "148分钟",
  },
  {
    id: 2,
    title: "长安三万里2",
    category: "movie",
    year: 2026,
    rating: 8.9,
    thumbnail: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20animated%20movie%20scene%20with%20poets%20in%20traditional%20robes%2C%20beautiful%20palace%20architecture%2C%20warm%20golden%20sunset%20lighting%2C%20cinematic%20animation%20style&width=640&height=360&seq=video-thumb-02&orientation=landscape",
    description: "安史之乱后，大唐盛世不再，高适与李白这对挚友各自辗转于命运的洪流之中。本片以独特视角重新诠释盛唐诗歌文化的辉煌与落幕，带领观众感受千年之前的文人风骨。",
    tags: ["动画", "历史", "诗歌", "国产"],
    director: "追光动画",
    cast: ["杨天翔", "凌振赫", "吴俊全"],
    duration: "168分钟",
  },
  {
    id: 3,
    title: "狂飙：终章",
    category: "tv",
    year: 2026,
    rating: 9.5,
    thumbnail: "https://readdy.ai/api/search-image?query=Crime%20drama%20TV%20series%20scene%20with%20police%20officers%20and%20undercover%20operation%2C%20tense%20atmosphere%2C%20dark%20alley%20at%20night%2C%20cinematic%20lighting%2C%20thriller%20style&width=640&height=360&seq=video-thumb-03&orientation=landscape",
    description: "在扫黑除恶常态化背景下，安欣与高启强之间的最终对决终于到来。二十年恩怨纠葛，正义与邪恶的终极较量，京海市的黑夜终将迎来黎明。",
    tags: ["犯罪", "剧情", "国产", "悬疑"],
    director: "徐纪周",
    cast: ["张译", "张颂文", "李一桐"],
    duration: "40集",
  },
  {
    id: 4,
    title: "庆余年2",
    category: "tv",
    year: 2026,
    rating: 9.3,
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20with%20ancient%20palace%20and%20swordsman%20in%20flowing%20robes%2C%20mysterious%20atmosphere%2C%20dramatic%20cinematic%20lighting%2C%20epic%20series%20poster&width=640&height=360&seq=video-thumb-04&orientation=landscape",
    description: "范闲身世之谜逐渐揭开，朝堂风云变幻，各方势力暗流涌动。在权力与情感的漩涡中，范闲将何去何从？第二季剧情更加扣人心弦。",
    tags: ["古装", "权谋", "喜剧", "国产"],
    director: "孙皓",
    cast: ["张若昀", "李沁", "陈道明"],
    duration: "36集",
  },
  {
    id: 5,
    title: "奔跑吧第八季",
    category: "variety",
    year: 2026,
    rating: 8.5,
    thumbnail: "https://readdy.ai/api/search-image?query=Outdoor%20variety%20show%20with%20celebrity%20guests%20running%20and%20playing%20games%20in%20colorful%20set%2C%20bright%20sunny%20day%2C%20energetic%20atmosphere%2C%20fun%20and%20entertaining&width=640&height=360&seq=video-thumb-05&orientation=landscape",
    description: "全新一季奔跑吧重磅回归！常驻MC阵容全面升级，更有超人气飞行嘉宾加盟。爆笑游戏、刺激挑战，每周五晚准时开跑！",
    tags: ["真人秀", "竞技", "搞笑", "国产"],
    director: "姚译添",
    cast: ["李晨", "郑恺", "杨颖", "白鹿"],
    duration: "12期",
  },
  {
    id: 6,
    title: "鬼灭之刃：无限城篇",
    category: "anime",
    year: 2026,
    rating: 9.7,
    thumbnail: "https://readdy.ai/api/search-image?query=Japanese%20anime%20demon%20slayer%20battle%20scene%20with%20swordsman%20and%20demons%2C%20dynamic%20action%20pose%2C%20vibrant%20color%20grading%2C%20anime%20movie%20style%20with%20dramatic%20effects&width=640&height=360&seq=video-thumb-06&orientation=landscape",
    description: "炭治郎一行人终于进入了鬼舞辻无惨的据点——无限城。面对上弦之鬼的围剿，鬼杀队展开了最终决战。史上最华丽的战斗篇章就此展开！",
    tags: ["热血", "战斗", "日漫", "奇幻"],
    director: "外崎春雄",
    cast: ["花江夏树", "鬼头明里", "下野纮"],
    duration: "110分钟",
  },
  {
    id: 7,
    title: "舌尖上的中国5",
    category: "documentary",
    year: 2026,
    rating: 9.1,
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20close-up%20of%20steaming%20hot%20dish%20with%20chef%20hands%20preparing%20traditional%20cuisine%2C%20warm%20kitchen%20lighting%2C%20appetizing%20food%20photography&width=640&height=360&seq=video-thumb-07&orientation=landscape",
    description: "第五季将镜头对准中国的街头美食文化。从东北的锅包肉到广东的肠粉，从西北的羊肉泡馍到江南的小笼包，带你领略最地道的中国味道。",
    tags: ["美食", "文化", "纪录", "国产"],
    director: "陈晓卿",
    cast: ["李立宏（旁白）"],
    duration: "8集",
  },
  {
    id: 8,
    title: "霸道总裁的甜蜜契约",
    category: "short",
    year: 2026,
    rating: 7.8,
    thumbnail: "https://readdy.ai/api/search-image?query=Romantic%20drama%20with%20handsome%20businessman%20and%20beautiful%20woman%20in%20modern%20office%20setting%2C%20soft%20romantic%20lighting%2C%20Korean%20drama%20style%20aesthetic&width=640&height=360&seq=video-thumb-08&orientation=landscape",
    description: "她是刚入职场的菜鸟秘书，他是冷酷无情的集团总裁。一份意外的契约，让两人的命运紧紧绑在一起。甜蜜又虐心的办公室恋情，每集10分钟，让你欲罢不能！",
    tags: ["甜宠", "都市", "短剧", "国产"],
    director: "未知",
    cast: ["林一", "赵露思"],
    duration: "80集",
  },
  {
    id: 9,
    title: "哪吒之魔童闹海2",
    category: "movie",
    year: 2026,
    rating: 9.6,
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20mythology%20animated%20movie%20with%20young%20warrior%20riding%20fire%20wheels%20in%20epic%20battle%2C%20dramatic%20red%20and%20gold%20color%20scheme%2C%20cinematic%20animation%20with%20special%20effects&width=640&height=360&seq=video-thumb-09&orientation=landscape",
    description: "天劫之后，哪吒和敖丙虽然保住了灵魂，但肉身濒临崩溃。太乙真人打算用七色宝莲为二人重塑肉身，过程中却遇到了重重困难。哪吒与敖丙的命运将何去何从？",
    tags: ["动画", "神话", "奇幻", "国产"],
    director: "饺子",
    cast: ["吕艳婷", "瀚墨", "陈浩"],
    duration: "144分钟",
  },
  {
    id: 10,
    title: "三体：黑暗森林",
    category: "tv",
    year: 2026,
    rating: 9.4,
    thumbnail: "https://readdy.ai/api/search-image?query=Sci-fi%20TV%20series%20with%20dark%20cosmic%20background%20and%20mysterious%20alien%20civilization%2C%20deep%20space%20theme%2C%20philosophical%20atmosphere%2C%20cinematic%20lighting%20with%20stars&width=640&height=360&seq=video-thumb-10&orientation=landscape",
    description: "面壁计划正式启动，四位面壁者开始与三体文明展开智慧博弈。罗辑发现了宇宙黑暗森林法则的秘密，人类的命运悬于一线。",
    tags: ["科幻", "悬疑", "国产", "史诗"],
    director: "杨磊",
    cast: ["张鲁一", "于和伟", "陈瑾"],
    duration: "30集",
  },
  {
    id: 11,
    title: "极限挑战第十季",
    category: "variety",
    year: 2026,
    rating: 8.8,
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20with%20celebrity%20cast%20doing%20funny%20challenges%20in%20urban%20city%2C%20colorful%20street%20scenes%2C%20comedic%20expressions%2C%20entertaining%20style&width=640&height=360&seq=video-thumb-11&orientation=landscape",
    description: "极限男人帮全新升级！更多不可能完成的任务，更多令人捧腹的瞬间。这就是命，这就是极限挑战！",
    tags: ["真人秀", "搞笑", "挑战", "国产"],
    director: "严敏",
    cast: ["黄渤", "孙红雷", "黄磊", "张艺兴"],
    duration: "12期",
  },
  {
    id: 12,
    title: "间谍过家家2",
    category: "anime",
    year: 2026,
    rating: 9.3,
    thumbnail: "https://readdy.ai/api/search-image?query=Japanese%20anime%20comedy%20with%20a%20family%20of%20spy%2C%20assassin%20and%20telepath%20girl%2C%20colorful%20and%20cute%20art%20style%2C%20warm%20family%20atmosphere%20with%20fun%20expressions&width=640&height=360&seq=video-thumb-12&orientation=landscape",
    description: "福杰一家继续他们的伪装生活！间谍爸爸、杀手妈妈、读心术女儿和预知未来的狗狗，这个看似普通却各怀绝技的家庭又会迎来怎样的冒险？",
    tags: ["喜剧", "日常", "日漫", "温馨"],
    director: "古桥一浩",
    cast: ["江口拓也", "种崎敦美", "早见沙织"],
    duration: "25集",
  },
];

export const articles = [
  {
    id: 1,
    title: "2026年最值得期待的十部国产大片",
    category: "movie",
    date: "2026-07-28",
    author: "苹果视频编辑部",
    summary: "2026年国产电影市场精彩纷呈，我们为你盘点了今年最值得期待的十部国产大片，从科幻到动画，从悬疑到喜剧，总有一部适合你。",
    content: `<p>2026年是中国电影产业蓬勃发展的一年，众多备受期待的国产大片即将与观众见面。我们精选了十部最值得关注的作品，为大家带来详细的观影指南。</p>
    <h3>1. 《流浪地球3》</h3>
    <p>作为中国科幻电影的标杆之作，《流浪地球》系列第三部将继续由郭帆执导，吴京、刘德华等原班人马回归。据悉本片在视觉效果上将有更大突破，故事也将更加宏大。</p>
    <h3>2. 《哪吒之魔童闹海2》</h3>
    <p>2019年《哪吒之魔童降世》创下了50亿的票房奇迹，续集自然备受关注。导演饺子透露，第二部将延续前作的精良制作，故事更加感人。</p>
    <h3>3. 《长安三万里2》</h3>
    <p>追光动画又一力作！第一部的成功证明了国产动画同样可以讲述深刻的历史故事。第二部将继续探索大唐诗人的传奇人生。</p>
    <p>还有更多精彩影片等待上映，让我们共同期待中国电影的美好未来！</p>`,
    thumbnail: "https://readdy.ai/api/search-image?query=Cinema%20movie%20theater%20with%20red%20curtains%20and%20bright%20stage%20lights%2C%20dramatic%20atmosphere%2C%20cinematic%20aesthetic%2C%20warm%20golden%20lighting&width=800&height=450&seq=article-thumb-01&orientation=landscape",
  },
  {
    id: 2,
    title: "狂飙终章：京海风云再起，正义终将到来",
    category: "tv",
    date: "2026-07-25",
    author: "苹果视频编辑部",
    summary: "《狂飙：终章》作为现象级剧集的完结篇，不仅延续了前作的超高水准，更在剧情深度和人物塑造上达到了新的高度。",
    content: `<p>自《狂飙》播出以来，这部扫黑除恶题材的电视剧就成为了全国观众热议的焦点。如今《狂飙：终章》的到来，为这个精彩的故事画上了一个圆满的句号。</p>
    <h3>剧情回顾</h3>
    <p>《狂飙：终章》讲述了在扫黑除恶常态化背景下，安欣与高启强之间的最终对决。二十年的恩怨纠葛，在这个篇章中得到了彻底的了结。</p>
    <h3>人物分析</h3>
    <p>张译饰演的安欣，从一个热血青年警察成长为成熟稳重的执法者。张颂文饰演的高启强，则是近年来国产剧中最具深度的反派角色之一。两人的对手戏堪称教科书级别的表演。</p>
    <h3>社会意义</h3>
    <p>《狂飙》系列的成功不仅仅在于其精良的制作和出色的表演，更在于它深刻地反映了中国社会的发展变迁，展现了法治建设的进步。</p>
    <p>无论你是老粉丝还是新观众，《狂飙：终章》都值得你花时间静心品味。</p>`,
    thumbnail: "https://readdy.ai/api/search-image?query=Crime%20drama%20TV%20series%20review%20article%20with%20police%20and%20criminal%20contrast%2C%20dramatic%20split%20lighting%2C%20professional%20film%20review%20aesthetic&width=800&height=450&seq=article-thumb-02&orientation=landscape",
  },
  {
    id: 3,
    title: "日漫推荐：2026夏季新番必看清单",
    category: "anime",
    date: "2026-07-22",
    author: "苹果视频编辑部",
    summary: "2026年夏季新番已经陆续开播，我们为你精选了本季最值得追的日漫作品，涵盖热血、恋爱、搞笑等多种类型。",
    content: `<p>2026年夏季新番阵容豪华，多部人气作品的续作和全新IP都将在这个夏天与大家见面。下面让我们一起来看看本季有哪些不容错过的作品。</p>
    <h3>《鬼灭之刃：无限城篇》</h3>
    <p>作为近年来最火爆的动漫IP之一，《鬼灭之刃》剧场版的质量从未让人失望。无限城篇的战斗场面堪称视觉盛宴，每一帧都可以截图做壁纸。</p>
    <h3>《间谍过家家2》</h3>
    <p>这部将间谍、杀手、读心术和家庭喜剧完美融合的作品，第二季继续保持着超高水准。安妮亚的表情包仍然是本季最大的快乐源泉。</p>
    <p>更多精彩新番等你来发现，快来苹果视频一睹为快吧！</p>`,
    thumbnail: "https://readdy.ai/api/search-image?query=Vibrant%20colorful%20anime%20collage%20with%20multiple%20popular%20anime%20characters%2C%20dynamic%20composition%2C%20energetic%20summer%20theme%2C%20anime%20magazine%20cover%20style&width=800&height=450&seq=article-thumb-03&orientation=landscape",
  },
  {
    id: 4,
    title: "家庭观影指南：适合全家人一起看的电影推荐",
    category: "movie",
    date: "2026-07-20",
    author: "苹果视频编辑部",
    summary: "周末到了，不知道和家人看什么？我们为你准备了一份全家欢观影清单，让每个家庭成员都能找到自己的快乐。",
    content: `<p>家庭观影时光是最温馨的回忆之一。选择一部适合全家人一起观看的电影，让欢乐翻倍。以下是我们的推荐。</p>
    <h3>动画片推荐</h3>
    <p>《长安三万里2》和《哪吒之魔童闹海2》都是优秀的国产动画，画面精美，故事感人，适合全家观看。</p>
    <h3>喜剧片推荐</h3>
    <p>轻松的喜剧片是家庭观影的最佳选择，让我们在欢笑中度过美好时光。</p>
    <p>打开苹果视频，选择一部好片，享受与家人在一起的幸福时刻吧！</p>`,
    thumbnail: "https://readdy.ai/api/search-image?query=Family%20watching%20movie%20together%20on%20sofa%20with%20popcorn%20in%20cozy%20living%20room%2C%20warm%20evening%20lighting%2C%20happy%20family%20atmosphere&width=800&height=450&seq=article-thumb-04&orientation=landscape",
  },
  {
    id: 5,
    title: "国产纪录片崛起：这些高分纪录片不容错过",
    category: "documentary",
    date: "2026-07-18",
    author: "苹果视频编辑部",
    summary: "近年来国产纪录片质量大幅提升，从美食到自然，从历史到科技，国产纪录片正在用镜头讲述精彩的中国故事。",
    content: `<p>曾几何时，纪录片是"小众"的代名词。但如今，优质的国产纪录片越来越多地走进大众视野，成为观众追捧的对象。</p>
    <h3>《舌尖上的中国5》</h3>
    <p>这部现象级美食纪录片第五季将镜头对准街头美食，以小见大，通过一道道接地气的美食，讲述普通中国人的生活故事。</p>
    <h3>纪录片的魅力</h3>
    <p>一部好的纪录片，不仅能增长知识，更能触动心灵。它们用真实的镜头语言，记录下这个时代最动人的故事。</p>
    <p>来苹果视频纪录片频道，发现更多精彩内容！</p>`,
    thumbnail: "https://readdy.ai/api/search-image?query=Documentary%20film%20production%20with%20camera%20equipment%20and%20beautiful%20nature%20landscape%2C%20professional%20cinematography%2C%20golden%20hour%20lighting&width=800&height=450&seq=article-thumb-05&orientation=landscape",
  },
];

export const faqs = [
  {
    question: "苹果视频需要付费吗？",
    answer: "不需要！苹果视频是一个完全免费的在线视频平台，所有电影、电视剧、综艺、动漫等资源均可免费观看，无需任何付费或订阅。",
  },
  {
    question: "观看视频需要注册账号吗？",
    answer: "不需要注册。苹果视频无需登录即可直接观看所有内容，我们致力于为用户提供最便捷的观影体验。",
  },
  {
    question: "为什么视频播放如此流畅？",
    answer: "苹果视频采用了先进的CDN加速技术和智能码率适配系统，能够根据用户的网络状况自动调整画质，确保在各种网络环境下都能流畅播放，告别卡顿和缓冲。",
  },
  {
    question: "苹果视频支持哪些设备观看？",
    answer: "苹果视频支持电脑、平板、手机等所有主流设备，无需下载任何APP，打开浏览器即可畅享高清视频。推荐使用Chrome、Safari等现代浏览器获得最佳体验。",
  },
  {
    question: "视频更新频率如何？",
    answer: "苹果视频每日更新最新影视资源。热播剧集同步更新，电影第一时间上线，确保你不会错过任何精彩内容。",
  },
  {
    question: "视频画质怎么样？",
    answer: "苹果视频提供高清画质（720P/1080P），部分热门影片更支持超清4K画质，让你享受影院级的观影体验。",
  },
];

export const aboutInfo = {
  brandName: "苹果视频",
  slogan: "免费高清 · 流畅不卡顿 · 随时随地想看就看",
  introduction: "苹果视频成立于2020年，是国内领先的免费在线视频平台之一。我们致力于为用户提供丰富、优质、免费的影视内容，汇聚电影、电视剧、综艺、动漫、纪录片等多种类型的视频资源。凭借先进的技术架构和优质的资源整合能力，苹果视频为数千万用户提供了流畅稳定的观影体验。",
  mission: "让每个人都能轻松享受高品质的观影体验，是苹果视频始终不变的使命。",
  history: [
    { year: "2020年", event: "苹果视频正式上线，以免费高清为特色进入市场" },
    { year: "2021年", event: "用户突破100万，完成首轮技术架构升级" },
    { year: "2022年", event: "引入CDN加速技术，实现全国范围内流畅播放" },
    { year: "2023年", event: "用户突破1000万，成为国内知名视频平台" },
    { year: "2024年", event: "推出4K超清画质，观影体验全面升级" },
    { year: "2025年", event: "内容库突破10万部，覆盖全球热门影视资源" },
    { year: "2026年", event: "用户突破5000万，持续引领免费视频平台发展" },
  ],
  testimonials: [
    { name: "张先生", role: "资深影迷", content: "苹果视频真的太棒了！资源丰富，画质清晰，最重要的是完全免费。我每天都会在这里看一部电影，已经成了生活中不可或缺的一部分。" },
    { name: "李女士", role: "追剧达人", content: "追剧追了这么多年，苹果视频是我用过最流畅的平台。热播剧更新快，而且从来不卡顿，五星推荐！" },
    { name: "王同学", role: "大学生", content: "作为学生党，苹果视频完全满足了我的观影需求。不用付费、不用注册，打开就能看，太方便了。" },
    { name: "赵女士", role: "全职妈妈", content: "孩子喜欢看动画片，我就在苹果视频上找。资源特别全，国产的国外的都有，画面清晰，孩子看得开心我也放心。" },
  ],
  contact: {
    email: "service@apple-video.com",
    wechat: "AppleVideo_Official",
    weibo: "@苹果视频官方",
    address: "北京市朝阳区望京科技园A座",
    phone: "400-888-0000",
  },
};